import { IOption } from '@/interfaces';

import { RoleStatus } from '@/features/role-assignments/enums';
import { getRoleStatusLabel } from '@/features/role-assignments/utils';

export const ROLE_STATUS_OPTIONS: IOption[] = [
  {
    label: getRoleStatusLabel(RoleStatus.Active),
    value: RoleStatus.Active.toString(),
  },
  {
    label: getRoleStatusLabel(RoleStatus.Inactive),
    value: RoleStatus.Inactive.toString(),
  },
];
